<i18n src="../../locales/lang.json"></i18n>

<template>
  <div ref="container" id="menucontainer" class="sidebar sidebar-dark skin adminmenu-bg sidebar-main sidebar-expand-lg shadow-0" style="width: 205px; display: inline-table; position: relative; left: 0px; margin-left:0px;">
    <div class="sidebar-section sidebar-user">
      <div class="sidebar-section-body pr-2">
        <div class="media">

          <div class="media-body">
            <!--<div v-show="expanded == true" class="font-weight-semibold mt-1">Admin menu</div>-->
          </div>
          <div class="pull-right" style="display: block !important;">
            <button @click="expand" type="button" class="btn btn-outline-light-100 border-transparent btn-icon rounded-pill btn-sm sidebar-control sidebar-main-resize d-none d-lg-inline-flex" style="color:inherit;background-color: rgba(255,255,255,0.5);">
              <i v-show="expanded == false" class="icon-arrow-right32"></i>
              <i v-show="expanded == true" class="icon-arrow-left32"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="sidebar-section sidebar-user">
      <menu-item class="nav nav-sidebar" v-model="items" @expanditem="expandItem" @clickItem="clickItem" @multipleClickItem="multipleClickItem" />
    </div>
  </div>
</template>

<script>

  import MenuItem from './menu-item.vue'
  import { TimelineLite } from 'gsap'
  import { gsap } from 'gsap';

  var showing = true;
  var expanded = true;
  var items = [];
  var showSections = [];
  var showSubSections = [];
  var selectedItem = {
    expanded: false,
    Elements: [],
    Text: null
  };

  export default {
    name: "desktop-vertical-menu",
    components: {
      MenuItem,
      TimelineLite,
      gsap
    },
    props: {
      option: {
        required: false,
        type: String,
        default: null
      }
    },
    data() {
      return {
        items,
        selectedItem,
        expanded,
        showing,
        showSections: [],
        showSubSections: [],
      };
    },

    methods: {
      hide(timeout = 2500) {

        var thisContext = this;
        if (this.showing == false)
          return;

        //setTimeout(function () {
          if (!$('#menucontainer').hasClass("sidebar-main-resized"))
            $('#menucontainer').addClass("sidebar-main-resized")
        //}, timeout + 1000)

        $('#menucontainer').width('55px')
        thisContext.showing = false;

        /*
        setTimeout(function () {
          const timeline2 = new TimelineLite({ paused: true })
          timeline2.set(thisContext.$refs["container"], { width: '250px' }, 'start');
          timeline2.from(thisContext.$refs["container"], 0.7, { width: "250px", ease: "none" }, 'start+=0.001')
          timeline2.to(thisContext.$refs["container"], { width: "55px", ease: "none" });
          
          timeline2.resume();

        }, timeout)
        */
      },
      show(timeout = 5000) {

        var thisContext = this;
        if (this.showing == true)
          return;
        this.showing = true;

        if ($('#menucontainer').hasClass("sidebar-main-resized"))
          $('#menucontainer').removeClass("sidebar-main-resized")

        $('#menucontainer').width('250px');
        /*
        setTimeout(function () {
          
        }, 300)

        setTimeout(function () {
          const timeline2 = new TimelineLite({ paused: true })
          timeline2.set(thisContext.$refs["container"], { width: '55px' }, 'start');
          timeline2.from(thisContext.$refs["container"], { width: "55px", ease: "none" });
          timeline2.to(thisContext.$refs["container"], { ease: "none", duration: 0.2, width: "250px" })
          timeline2.resume();
          //thisContext.hide(timeout);
        }, 1)
          */
      },
      expand() {
        
        this.expanded = !this.expanded;
        if (this.expanded == true)
          this.show(100);
        else
          this.hide(100);
        
      },
      expandItem(item) {
        this.expanded = true;
      },
      multipleClickItem(item) {
        if (this.showing === false) {         
          this.clickItem(item);         
        }
      },
      clickItem(item) {

        if (this.option != null) {
          // Calling the function name in the parameter
          eval(this.option + "(item);");
        }
        this.selectedItem.selected = false;
        this.selectedItem = item;
        this.$root.$emit('menu-item-selected', item);
        this.show(100);        
      },
      //manageSections() {
      //  try {
      //    var url = '/api/Site/GetCurrentSite';
      //    this.$http.get(url).then(async response => {
      //      var data = response.data;
      //      console.log(data);
      //      if (data.sections !== '' && data.sections !== null) {
      //        this.showSections = data.sections;

      //      }
      //      var elements = [];
      //      if (this.$store.getInstallationType() == "Education") {
      //        elements = this.getMiniMenu();
      //      }
      //      else {
      //        elements = this.getDefaultMenu();
      //      }
      //      this.items = elements;
      //      this.$forceUpdate();
      //    });
      //  }
      //  catch (err) {
      //    //alert('some error:' + err)
      //  }
      //},
      manageSections(sections, subSections) {
        if (sections !== '' && sections !== null) {
          this.showSections = sections;
          this.showSubSections = subSections;
        }
        var elements = [];
        if (this.$store.getInstallationType() == "Education") {
          elements = this.getMiniMenu();
        }
        else {
          elements = this.getDefaultMenu();
        }
        this.items = elements;
        this.$forceUpdate();
      },
      isSubSectionAdded(section) {
        if (this.showSubSections !== null) {
          var index = this.showSubSections.indexOf(section);
          if (index > -1) {
            return true;
          }
          return false;
        }
        return true;
      },
      isSectionAdded(section) {
        if (this.showSections !== null) {
          var index = this.showSections.indexOf(section);
          if (index > -1) {
            return true;
          }
          return false;
        }
        return true;
      },
      getDefaultMenu() {
        //var elements = [
        //  {
        //    Text: this.$t('adminmenu_members'),
        //    Icon: "icon-users4",
        //    Elements: [
        //      {
        //        Text: this.$store.translate('adminmenu_users'),
        //        Option: "users",
        //        Elements: []
        //      },
        //      {
        //        Text: this.$store.translate('adminmenu_administrator'),
        //        Option: "admins",
        //        Elements: []
        //      },
        //      {
        //        Text: this.$t('adminmenu_teams'),
        //        Option: "teams",
        //        Elements: [],
        //      },
        //      {
        //        Text: this.$t('adminmenu_organisations'),
        //        Option: "organisations",
        //        Elements: [],
        //      }
        //    ]
        //  },
        //  {
        //    Text: this.$t('adminmenu_projects'),
        //    Icon: "icon-collaboration",
        //    Option: "projects",
        //    Elements: []
        //  },
        //  {
        //    Text: this.$store.translate('adminmenu_locations'),
        //    Option: "locations",
        //    Icon: "icon-location3",
        //    Elements: []
        //  },
        //  {
        //    Text: this.$store.translate('adminmenu_shifts'),
        //    Icon: "icon-make-group",
        //    Elements: [
        //      {
        //        Text: this.$store.translate('adminmenu_administrate_shifts'),
        //        Option: "shiftAdmin",
        //        Elements: []
        //      }
        //    ]
        //  },
        //  {
        //    Text: this.$t('adminmenu_sheduling'),
        //    Icon: "icon-calendar",
        //    Elements: [

        //      {
        //        Text: this.$t('adminmenu_user_scheduling'),
        //        Option: "userScheduleAdmin",
        //        Elements: []
        //      },
        //      {
        //        Text: this.$store.translate('adminmenu_plan_shift'),
        //        Option: "locationShiftAdmin",
        //        Elements: []
        //      },
        //      {
        //        Text: this.$t('adminmenu_plan_tasks'),
        //        Option: "schedule",
        //        Elements: [],
        //      }
        //    ]
        //  },
        //  {
        //    Text: this.$t('adminmenu_general'),
        //    Icon: "icon-cog",
        //    Option: "general",
        //    Elements: [
        //    ]
        //  }
        //]
        var elements = [];

        elements.push({
          Text: this.$t('start'),
          Icon: "icon-home",
          Option: "startView",
          Elements: []
        });

        if (this.isSectionAdded('Members')) {
          var subSectionMembers = [];
          subSectionMembers.push({
            Text: this.$store.translate('adminmenu_users'),
            Option: "users",
            Elements: []
          });
          subSectionMembers.push({
            Text: this.$store.translate('adminmenu_pending_users'),
            Option: "pendingusers",
            Elements: []
          });
          subSectionMembers.push({
            Text: this.$store.translate('adminmenu_administrator'),
            Option: "admins",
            Elements: []
          });
          subSectionMembers.push({
            Text: this.$t('adminmenu_teams'),
            Option: "teams",
            Elements: [],
          });
          if (this.isSubSectionAdded('Clients')) {
            subSectionMembers.push({
              Text: this.$t('adminmenu_organisations'),
              Option: "organisations",
              Elements: [],
            });
          }

          elements.push({
            Text: this.$t('adminmenu_members'),
            Icon: "icon-users4",
            Elements: subSectionMembers
          });
        }
        if (this.isSectionAdded('Projects')) {
          elements.push({
            Text: this.$t('adminmenu_projects'),
            Icon: "icon-collaboration",
            Option: "projects",
            Elements: []
          });
        }
        if (this.isSectionAdded('Locations')) {
          elements.push({
            Text: this.$store.translate('adminmenu_locations'),
            Option: "locations",
            Icon: "icon-location3",
            Elements: []
          });
        }
        if (this.isSectionAdded('Shifts')) {
          elements.push({
            Text: this.$store.translate('adminmenu_shifts'),
            Icon: "icon-make-group",
            Elements: [
              {
                Text: this.$store.translate('adminmenu_administrate_shifts'),
                Option: "shiftAdmin",
                Elements: []
              }
            ]
          });
        }
        if (this.isSectionAdded('Planning') || this.isSectionAdded('Shifts')) {
          var eles = [];
          eles.push({
            Text: this.$t('adminmenu_user_scheduling'),
            Option: "userScheduleAdmin",
            Elements: []
          });
          eles.push({
            Text: this.$store.translate('adminmenu_plan_shift'),
            Option: "locationShiftAdmin",
            Elements: []
          });
          eles.push({
            Text: this.$store.translate('adminmenu_plan_weekly_shift'),
            Option: "locationShiftAdminNew",
            Elements: []
          });
          if (this.isSectionAdded('Planning')) {
            if (this.isSubSectionAdded('Tasks')) {
              eles.push({
                Text: this.$t('adminmenu_plan_tasks'),
                Option: "schedule",
                Elements: [],
              });
            }
          }
          elements.push({
            Text: this.$t('adminmenu_sheduling'),
            Icon: "icon-calendar",
            Elements: eles
          });
        }

        if (this.isSectionAdded('Bookings')) {
          var subSectionBookings = [];
          subSectionBookings.push({
            Text: this.$store.translate('adminmenu_booking_resource'),
            Option: "bookingresource",
            Elements: []
          });
          subSectionBookings.push({
            Text: this.$store.translate('adminmenu_booking_slot'),
            Option: "resourceslot",
            Elements: []
          });

          elements.push({
            Text: this.$t('adminmenu_booking'),
            Icon: "icon-users4",
            Elements: subSectionBookings
          });
        }
        elements.push({
          Text: this.$t('adminmenu_general'),
          Icon: "icon-cog",
          Option: "general",
          Elements: [
          ]
        });
        return elements;
      }
      ,
      getMiniMenu() {
        var elements = [
          {
            Text: this.$store.translate('adminmenu_users'),
            Icon: "icon-users ",
            Option: "users",
            Elements: []
          },
          {
            Text: this.$store.translate('adminmenu_pending_users'),
            Icon: "icon-users ",
            Option: "pendingusers",
            Elements: []
          },
          {
            Text: this.$store.translate('adminmenu_administrator'),
            Icon: "icon-user-tie",
            Option: "admins",
            Elements: []
          },
          {
            Text: this.$store.translate('adminmenu_teams'),
            Icon: "icon-users4",
            Option: "teams",
            Elements: [],
          },

          {
            Text: this.$t('adminmenu_sheduling'),
            Icon: "icon-calendar",
            Option: "teamTaskScheduling",
            Elements: []
          },
          {
            Text: this.$t('adminmenu_general'),
            Icon: "icon-cog",
            Option: "general",
            Elements: []
          }
        ]
        return elements;
      }


    },
    computed: {

    },
    mounted() {
      //var elements = [];
      //if (this.$store.getInstallationType() == "Education") {
      //  elements = this.getMiniMenu();
      //}
      //else {
      //  elements = this.getDefaultMenu();
      //}
      //this.items = elements;
      //this.$forceUpdate();
      //this.manageSections();
    },
    created: function () {

    },
    watch: {

    },
    created() {

    },
  };

</script>

<style scoped>
  .sidebar-dark {
    color: inherit;
  }
</style>

<style>
  @media (prefers-color-scheme: dark) {
  }
</style>





// WEBPACK FOOTER //
// src/components/navigation/desktop-vertical-menu.vue